import styled from '@emotion/styled';

export const EpisodeContentLabel = styled.h2`
  margin-bottom: 16px;
  color: #24203f;
  font-size: 2.4rem;
`;

export const UploaderStateContainer = styled.div<{
  containsMedia: boolean;
  isExpanded: boolean;
}>`
  width: 100%;
  height: ${({ isExpanded }) => (isExpanded ? '140' : '100')}px;
  border: 1px #dedfe0
    ${({ containsMedia }) => (containsMedia ? 'solid' : 'dashed')};
  border-radius: 8px;
  background: #ffffff;
`;

export const UploaderContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const UploaderLabelsContainer = styled.div`
  width: 100%;
`;

export const UploaderStatusHeading = styled.h2`
  margin: 0 0 8px 0;
  color: #24203f;
  font-size: 1.8rem;
  line-height: 21px;
`;

export const UploaderStatusLabel = styled.div`
  color: #7f8287;
  font-size: 1.2rem;
  line-height: 14px;
`;

export const UploaderStatusContainer = styled.div``;
